<template>
  <div>
    <div class="yCenter font-weight-bold">
      <div class="mx-2">
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn
              class="select-documents font-weight-bold white thinText--text"
              v-on="on"
              depressed
              outlined
              height="32px"
            >
              {{ $t('common.common_bulk-operation') }}
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="(item, i) in getBulkOperationItemList()"
              :key="i"
              :class="item.type === 'cancel' ? 'list-item-cancel' : ''"
              @click="clickBulkOperationItem(item.type)"
            >
              <v-list-item-content>
                <v-list-item-title>
                  {{ $t(item.title) }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
      <WithDrawBulkOperationDialog
        :visible.sync="withdraw.dialog"
        :items="items"
        :historyList="historyList"
      />

      <OrderCompleteBulkOperationDialog
        :visible.sync="complete.dialog"
        :items="items"
        :historyList="historyList"
      />

      <!-- <NormalButton
        :text="$t('common.common_document')"
        height="32px"
        width="15px"
        color="white"
        textColor="thinText--text"
        :outlined="true"
        @click="submit()"
      /> -->
      <BulkOperationDocuments @submit="submit" />

      <!-- <CompleteDialog
        v-model="complete"
        @complete="completeMethod"
        title="aaaaaaaaaaa"
      /> -->
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import NormalButton from '@/components/items/Buttons/NormalButton'
import {
  WithDrawBulkOperationDialog,
  OrderCompleteBulkOperationDialog
} from '@/components/layouts/Dialogs'
import BulkOperationDocuments from './BulkOperationDocuments'

// import CompleteDialog from '@/components/layouts/Dialogs/CompleteDialog'
// import { CompleteDialog } from '@/components/layouts'

export default {
  name: 'BulkOperationButtons',
  components: {
    NormalButton,
    WithDrawBulkOperationDialog,
    OrderCompleteBulkOperationDialog,
    BulkOperationDocuments
    // CompleteDialog
  },
  props: {
    items: [],
    historyList: []
  },
  data: () => ({
    statusHistoryDialog: false,
    withdraw: { dialog: false },
    complete: {
      dialog: false
    }
  }),
  methods: {
    ...mapActions('Order', ['bulkCancelOrder']),
    ...mapActions('Common', ['setIsLoading']),
    getWidth(value) {
      const obj = this.headers.find((ele) => ele.value === value)
      return obj ? obj.width : '100px'
    },
    getCustomerrName(id) {
      return id
    },
    getUserName(id) {
      return id
    },
    getAmount(id) {
      return this.items.productMoves.reduce(
        (accumulator, currentValue, currentIndex, array) => {
          const count = currentValue.quantity * currentValue.price
          return accumulator + count
        },
        0
      )
    },

    completeMethod() {
      alert(this.$t('sale.sale_completion-date') + this.complete.dialog.date)
      // ここに登録処理
      // ...

      this.complete.dialog.dialog = false
    },
    submit(type) {
      const ids = this.items.filter((d) => d.checkFlg)
      if (!ids.length) {
        return
      }
      this.$emit('onClickLedgerSheet', type, ids)
    },
    getBulkOperationItemList() {
      if (this.authority.isAdmin) {
        return [
          {
            title: this.$t('storage.storage_payment-operation'),
            type: 'withdraw'
          },
          {
            title: this.$t('order.order_ordering-operation'),
            type: 'complete'
          },
          {
            title: this.$t('user.user_cancel'),
            type: 'cancel'
          }
        ]
      }
      return []
    },
    async clickBulkOperationItem(type) {
      if (type === 'withdraw') {
        this.withdraw.dialog = true
      } else if (type === 'complete') {
        this.complete.dialog = true
      } else if (type === 'cancel') {
        this.cancel()
      }
    },
    async cancel() {
      const checkedItems = this.items.filter((item) => item.checkFlg)
      if (checkedItems.length === 0) {
        alert(this.$t('sale.sale_order-not-selected'))
        return
      }

      const isConfirmed = confirm(`
        ${this.$t('order.order_restore-order-confirm')}`)
      if (!isConfirmed) {
        return
      }
      this.setIsLoading(true)

      const orderList = []
      checkedItems.forEach((item) => {
        orderList.push({
          orderId: item.id
        })
      })
      const errors = await this.bulkCancelOrder({ orderList })

      if (!errors) {
        this.setIsLoading(false)
        return
      }

      const ids = Object.keys(errors)
      if (ids.length === 0) {
        // 成功
        alert(this.$t('common.common_canceled-alert'))
      } else {
        let alertText = ''
        checkedItems.forEach((item) => {
          alertText += this.$t('sale.sale_sale-number')
          const history = this.historyList.filter((history) => {
            return history.orderId === item.id
          })[0]
          alertText += `${history.transaction.controlNumber}:`
          const id = ids.filter((id) => {
            return Number(id) === item.id
          })
          if (id.length > 0) {
            // エラー
            alertText += errors[id[0]]
          } else {
            // 成功
            alertText += this.$t('common.common_canceled-alert')
          }
          if (history !== checkedItems[checkedItems.length - 1]) {
            alertText += '\n'
          }
        })
        alert(alertText)
      }

      this.setIsLoading(false)
      // アラート確認後はリロード
      this.$router.go({
        path: this.$router.currentRoute.path,
        force: true
      })
    }
  },
  computed: {
    ...mapGetters('User', ['authority'])
  }
}
</script>
<style lang="scss" scoped>
.btnStyle {
  max-width: 105px;
  padding: 0px !important;
}
.select-documents {
  width: 60px;
  height: 32px !important;
  font-size: 12px;
  border: thin solid #c8cfd7 !important;
}
.list-item-cancel {
  border-top: 1px solid #d8d8d8;
}
</style>
